<template>
	<section class="Testimonial">
		<div class="container">
			<article class="content-testimonial">

				<p class="title-testimonial">
					{{$t("home.depoimentos")}}
				</p>

				<div v-for="depoimento in testimonial" class="container-testimonial">
					<p class="sub-title-testimonial" v-html="depoimento.content">
						{{ depoimento.content }}
					</p>

					<p class="signature">
						{{ depoimento.name }} - {{ depoimento.position }}
					</p>
				</div>
			</article>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["testimonial"]
    }
</script>

<style lang="scss">

	.container-testimonial {
		margin-bottom: 50px;
	}

	.Testimonial {
		background-color: #eee;
		padding-bottom: 60px;

		.content-testimonial {
			text-align: left;
			border-top: 2px solid #e0e0e0;
			padding-top: 30px;

			p.title-testimonial {
				font-size: 20px;
				padding: 20px 0;
			}

			p.sub-title-testimonial {
				font-size: 16px;
				font-style: italic;
				line-height: 25px;
			}

			p.signature {
				font-size: 16px;
				font-weight: bold;
				padding-top: 20px;
				font-style: italic;
			}
		}
	}

	@media(max-width: 1024px) {
		.Testimonial {
			.container {
				max-width: 100%;
				width: calc(100% - 30px);
				padding: 0 15px;

				.content-testimonial {
					width: 90%;
					margin: 0 auto;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/Testimonial.vue